import { createStore } from "vuex";

// import the auto exporter
import modules from "../stores";

export default createStore({
  modules,
});
